export default function OldHousingSupport() {
  return (
    <section className="py-20 bg-[#F5F3EF]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#2C4A3E] mb-4">
            15년 이상 노후주택 지원사업
          </h2>
          <p className="text-lg text-gray-600">
            안전진단부터 보조금 신청까지 단계별 안내
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {/* Card 1 */}
          <div className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center">
                <i className="ri-home-4-line text-5xl text-[#2C4A3E]"></i>
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">지원 대상 주택</h3>
            <p className="text-gray-600 leading-relaxed text-sm text-center">
              준공 후 15년 이상 경과, 안전등급 C등급 이하, 소득 기준 충족
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center">
                <i className="ri-tools-line text-5xl text-[#2C4A3E]"></i>
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">수리 및 개선 지원</h3>
            <p className="text-gray-600 leading-relaxed text-sm text-center">
              지붕, 외벽, 단열, 설비 개선 공사 최대 1,200만원 보조금 지원
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center">
                <i className="ri-file-list-3-line text-5xl text-[#2C4A3E]"></i>
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">신청 방법 및 서류</h3>
            <p className="text-gray-600 leading-relaxed text-sm text-center">
              주민센터 방문 또는 온라인 신청, 등기부등본, 안전진단서 등 제출
            </p>
          </div>
        </div>

        {/* Detailed Process */}
        <div className="bg-white rounded-3xl p-10 shadow-lg">
          <h3 className="text-2xl font-bold text-[#2C4A3E] mb-8 text-center">
            노후주택 지원 신청 절차
          </h3>

          <div className="space-y-6">
            {/* Step 1 */}
            <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
              <div className="flex-shrink-0 w-12 h-12 bg-[#2C4A3E] rounded-full flex items-center justify-center">
                <span className="text-white font-bold">1</span>
              </div>
              <div className="flex-1">
                <h4 className="text-lg font-bold text-gray-900 mb-2">신청 자격 확인</h4>
                <p className="text-sm text-gray-600 mb-2">
                  준공 후 15년 이상 경과한 주택 소유자 또는 임차인
                </p>
                <p className="text-xs text-gray-500">
                  필요 서류: 건축물대장, 등기부등본, 소득증명서
                </p>
              </div>
              <div className="text-sm text-[#D97642] font-semibold whitespace-nowrap">1-2일</div>
            </div>

            {/* Step 2 */}
            <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
              <div className="flex-shrink-0 w-12 h-12 bg-[#2C4A3E] rounded-full flex items-center justify-center">
                <span className="text-white font-bold">2</span>
              </div>
              <div className="flex-1">
                <h4 className="text-lg font-bold text-gray-900 mb-2">안전 진단 신청</h4>
                <p className="text-sm text-gray-600 mb-2">
                  지자체 또는 전문 기관에 안전진단 신청 및 현장 조사
                </p>
                <p className="text-xs text-gray-500">
                  담당 기관: 시·군·구청 주택과 또는 한국시설안전공단
                </p>
              </div>
              <div className="text-sm text-[#D97642] font-semibold whitespace-nowrap">7-10일</div>
            </div>

            {/* Step 3 */}
            <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
              <div className="flex-shrink-0 w-12 h-12 bg-[#2C4A3E] rounded-full flex items-center justify-center">
                <span className="text-white font-bold">3</span>
              </div>
              <div className="flex-1">
                <h4 className="text-lg font-bold text-gray-900 mb-2">보조금 신청</h4>
                <p className="text-sm text-gray-600 mb-2">
                  안전진단 결과서를 첨부하여 보조금 신청서 제출
                </p>
                <p className="text-xs text-gray-500">
                  신청 방법: 주민센터 방문 또는 온라인 신청 (복지로 웹사이트)
                </p>
              </div>
              <div className="text-sm text-[#D97642] font-semibold whitespace-nowrap">3-5일</div>
            </div>

            {/* Step 4 */}
            <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
              <div className="flex-shrink-0 w-12 h-12 bg-[#2C4A3E] rounded-full flex items-center justify-center">
                <span className="text-white font-bold">4</span>
              </div>
              <div className="flex-1">
                <h4 className="text-lg font-bold text-gray-900 mb-2">심사 및 승인</h4>
                <p className="text-sm text-gray-600 mb-2">
                  지자체 심사 후 지원 대상 선정 및 보조금 지급 결정
                </p>
                <p className="text-xs text-gray-500">
                  심사 기준: 주택 노후도, 소득 수준, 안전등급 등 종합 평가
                </p>
              </div>
              <div className="text-sm text-[#D97642] font-semibold whitespace-nowrap">10-15일</div>
            </div>

            {/* Step 5 */}
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-[#2C4A3E] rounded-full flex items-center justify-center">
                <span className="text-white font-bold">5</span>
              </div>
              <div className="flex-1">
                <h4 className="text-lg font-bold text-gray-900 mb-2">공사 진행 및 완료</h4>
                <p className="text-sm text-gray-600 mb-2">
                  승인된 업체를 통해 수리 및 개선 공사 진행, 완료 후 보조금 지급
                </p>
                <p className="text-xs text-gray-500">
                  공사 기간: 30-60일 (공사 범위에 따라 상이)
                </p>
              </div>
              <div className="text-sm text-[#D97642] font-semibold whitespace-nowrap">30-60일</div>
            </div>
          </div>
        </div>

        {/* Contact Info */}
        <div className="mt-12 bg-gradient-to-r from-[#2C4A3E] to-[#3d6454] rounded-2xl p-8 text-white text-center">
          <h4 className="text-2xl font-bold mb-4">담당 기관 연락처</h4>
          <div className="grid md:grid-cols-3 gap-6 mt-6">
            <div>
              <p className="text-sm opacity-80 mb-1">국토교통부 콜센터</p>
              <p className="text-xl font-bold">1599-0001</p>
            </div>
            <div>
              <p className="text-sm opacity-80 mb-1">한국시설안전공단</p>
              <p className="text-xl font-bold">1588-9234</p>
            </div>
            <div>
              <p className="text-sm opacity-80 mb-1">주거복지센터</p>
              <p className="text-xl font-bold">1600-1004</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
